import React, { useState } from "react";
import { useApp } from "../context/AppContext";
import PageSeo from "../components/PageSeo";


const difficultyColors = {
  easy: "var(--success)",
  medium: "var(--warning)",
  hard: "var(--danger)",
};

export default function RoutesPage() {
const { ROUTES_DATA, user } = useApp();
  const [selectedDifficulty, setSelectedDifficulty] = useState("all");
  const [selectedRoute, setSelectedRoute] = useState(null);

  const filteredRoutes =
    selectedDifficulty === "all"
      ? ROUTES_DATA
      : ROUTES_DATA.filter((route) => route.difficulty === selectedDifficulty);

return (
  <>
    <div style={{ padding: "32px 36px", maxWidth: 980 }}>
      <PageSeo
        title="Best Bike Routes in India | Motorcycle Route Planner | MotoHub India"
        description="Discover scenic bike routes in India for touring, weekend rides, mountain roads, and long-distance motorcycle trips with MotoHub India."
        keywords={[
          "best bike routes in India",
          "motorcycle route planner India",
          "road trips for bikers India",
          "bike touring routes India",
          "weekend rides India",
          "motorcycle trips India",
        ]}
        path="/routes"
      />
      <div className="fade-up" style={{ marginBottom: 24 }}>
        <div style={{ fontFamily: "var(--font-display)", fontSize: 36, letterSpacing: 1 }}>
          RIDING ROUTES
          
</div>
        </div>
        <div style={{
  color: "#aaa",
  maxWidth: "700px",
  lineHeight: "1.6",
  marginTop: "10px",
  marginBottom: "20px"
}}>
  Discover the best bike routes near {user?.city || "your city"}, including trending weekend rides,
  scenic mountain roads, and long-distance touring routes across India. Plan your next ride with MotoHub India.
        <div style={{ fontSize: 13, color: "var(--text2)" }}>
          Discover curated road trips across India for every riding style.
        </div>
      </div>

      <div className="fade-up-1" style={{ display: "flex", gap: 8, marginBottom: 20, flexWrap: "wrap" }}>
        {["all", "easy", "medium", "hard"].map((level) => (
          <button
            key={level}
            onClick={() => setSelectedDifficulty(level)}
            style={{
              padding: "8px 16px",
              borderRadius: 999,
              background: selectedDifficulty === level ? "var(--brand)" : "var(--bg2)",
              color: selectedDifficulty === level ? "#fff" : "var(--text2)",
              border: `1px solid ${selectedDifficulty === level ? "var(--brand)" : "var(--border)"}`,
              textTransform: "capitalize",
            }}
          >
            {level}
          </button>
        ))}
      </div>

      <div className="fade-up-2" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 14 }}>
        {filteredRoutes.map((route) => (
          <div
            key={route.id}
            onClick={() => setSelectedRoute(route)}
            style={{
              background: "var(--bg2)",
              border: "1px solid var(--border)",
              borderRadius: "var(--radius-lg)",
              padding: "18px 20px",
              cursor: "pointer",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", gap: 12, marginBottom: 10 }}>
              <div style={{ fontSize: 16, fontWeight: 600 }}>{route.name}</div>
              <span
                style={{
                  fontSize: 11,
                  padding: "3px 8px",
                  borderRadius: 999,
                  textTransform: "capitalize",
                  background: "var(--bg3)",
                  color: difficultyColors[route.difficulty],
                }}
              >
                {route.difficulty}
              </span>
            </div>
            <div style={{ fontSize: 13, color: "var(--text2)", marginBottom: 10 }}>
              {route.state} � {route.distance} km � Best in {route.season}
            </div>
            <div style={{ fontSize: 13, color: "var(--text3)", lineHeight: 1.6 }}>{route.desc}</div>
          </div>
        ))}
      </div>

      {selectedRoute && (
        <div
          onClick={() => setSelectedRoute(null)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 20,
            zIndex: 100,
          }}
        >
          <div
            onClick={(event) => event.stopPropagation()}
            style={{
              width: "100%",
              maxWidth: 520,
              background: "var(--bg2)",
              border: "1px solid var(--border2)",
              borderRadius: "var(--radius-lg)",
              padding: 24,
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", gap: 12, marginBottom: 14 }}>
              <div>
                <div style={{ fontFamily: "var(--font-display)", fontSize: 24 }}>{selectedRoute.name}</div>
                <div style={{ fontSize: 13, color: "var(--text2)", marginTop: 4 }}>
                  {selectedRoute.state} � {selectedRoute.altitude} � {selectedRoute.rating}/5 rating
                </div>
              </div>
              <button onClick={() => setSelectedRoute(null)} style={{ background: "none", color: "var(--text2)", fontSize: 20 }}>
                x
              </button>
            </div>

            <div style={{ fontSize: 14, color: "var(--text2)", lineHeight: 1.7, marginBottom: 16 }}>
              {selectedRoute.desc}
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 16 }}>
              {[
                ["Distance", `${selectedRoute.distance} km`],
                ["Best Season", selectedRoute.season],
                ["Difficulty", selectedRoute.difficulty],
                ["Altitude", selectedRoute.altitude],
              ].map(([label, value]) => (
                <div
                  key={label}
                  style={{
                    background: "var(--bg3)",
                    borderRadius: "var(--radius)",
                    padding: "10px 12px",
                  }}
                >
                  <div style={{ fontSize: 10, color: "var(--text3)", textTransform: "uppercase", letterSpacing: 1 }}>
                    {label}
                  </div>
                  <div style={{ fontSize: 13, fontWeight: 500, marginTop: 4, textTransform: "capitalize" }}>
                    {value}
                  </div>
                </div>
              ))}
            </div>

            <div style={{ fontSize: 11, color: "var(--text3)", textTransform: "uppercase", letterSpacing: 1, marginBottom: 8 }}>
              Highlights
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
              {selectedRoute.highlights.map((highlight) => (
                <span
                  key={highlight}
                  style={{
                    background: "var(--bg3)",
                    border: "1px solid var(--border)",
                    borderRadius: 999,
                    padding: "6px 12px",
                    fontSize: 12,
                    color: "var(--text2)",
                  }}
                >
                  {highlight}
                </span>
              ))}
            </div>
          </div>
        </div>
      )}
  </div>
</>
  );
}
